import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/skuOptionsPLP/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { SHOW_SKU_OPTIONS_PLP } from 'constants/TestTarget';

const showSkuOptionsPLPSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: testReady && experience === SHOW_SKU_OPTIONS_PLP.CHALLENGER_ONE,
    challengerTwo: testReady && experience === SHOW_SKU_OPTIONS_PLP.CHALLENGER_TWO
}));

export { showSkuOptionsPLPSelector };
